import { FC } from "react";
import { useAuth } from "../../context/AuthContext";

type Props = {
  permission: string;
  children: any;
};
const WithPermission: FC<Props> = ({ permission, children }) => {
  const { user, hasPermission } = useAuth();
  if (!user) return <></>;
  return user.role === "ADMIN" || hasPermission(permission) ? children : null;
};

export default WithPermission;
